import React, { Component } from "react";
import HorizontalFillLayout from "../../layout/fill/HorizontalFillLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class HorizontalFillLayoutDemo extends Component {
  render() {
    return (
      <HorizontalFillLayout vgap={20}>
        <CenterLayout className="bg1">HorizontalFill</CenterLayout>
        <CenterLayout className="bg2">HorizontalFill</CenterLayout>
      </HorizontalFillLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.horizontalFillLayout.js